"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _v = _interopRequireDefault(require("uuid/v4"));
var _AttendanceForm = _interopRequireDefault(require("./components/AttendanceForm"));
var _UploadFileUtil = _interopRequireDefault(require("@/views/mixin/UploadFileUtil"));
var _FirebaseStorageUtil = _interopRequireDefault(require("@/views/mixin/FirebaseStorageUtil"));
var _apolloClient = require("@/apollo/apolloClient");
var _clientMutation = require("@/apollo/mutations/client-mutation");
var _auth = require("@/utils/auth");
var _DocumentCategory = require("@/lib/enum/DocumentCategory");
var _appUtil = require("@/utils/app-util");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    AttendanceForm: _AttendanceForm.default
  },
  mixins: [_UploadFileUtil.default, _FirebaseStorageUtil.default],
  data: function data() {
    return {
      waitDialogVisible: false,
      form: {
        title: '',
        pdf_file: '',
        fileUrl: '',
        fileName: '',
        attachFileType: 0
      },
      showForm: {
        title: true,
        pdf_file: true
      },
      submitBtnName: '追加',
      loading: false
    };
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _t;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return (0, _appUtil.checkReadingFlag)(true);
          case 1:
            _t = _context.sent;
            if (!(_t === true)) {
              _context.next = 2;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  beforeDestroy: function () {
    var _beforeDestroy = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _t2;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return (0, _appUtil.checkReadingFlag)(false);
          case 1:
            _t2 = _context2.sent;
            if (!(_t2 === true)) {
              _context2.next = 2;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function beforeDestroy() {
      return _beforeDestroy.apply(this, arguments);
    }
    return beforeDestroy;
  }(),
  methods: {
    backToAttendanceIndex: function backToAttendanceIndex() {
      return this.$router.push({
        name: 'AttendanceIndex',
        params: {
          id: (0, _auth.getClientID)()
        }
      });
    },
    insertAttendance: function () {
      var _insertAttendance = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(form) {
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              console.log('insertAttendance');
              _context3.next = 1;
              return _apolloClient.apolloClient.mutate({
                mutation: _clientMutation.CREATE_DOCUMENT,
                variables: {
                  objects: {
                    title: form.title,
                    client_id: (0, _auth.getClientID)(),
                    file_url: form.fileUrl,
                    file_name: form.fileName,
                    file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationAttendance.val,
                    attach_file_type: form.attachFileType,
                    is_acceptance: false,
                    admin_reading_flag: true
                  }
                }
              }).then(function (result) {
                _apolloClient.apolloClient.resetStore();
                console.log('AttendanceResolve');
                var resultAttendance = result.data.insert_client_file_link.returning[0];
                return Promise.resolve(resultAttendance);
              }).catch(function (error) {
                console.log('AttendanceError');
                return Promise.reject(error);
              });
            case 1:
              return _context3.abrupt("return", _context3.sent);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function insertAttendance(_x) {
        return _insertAttendance.apply(this, arguments);
      }
      return insertAttendance;
    }(),
    postFormSubmit: function () {
      var _postFormSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(form, fileList) {
        var _this = this;
        var attachFileType, fileName, fileUrl, file, path, fileData;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.loading = true;
              this.waitDialogVisible = true;
              attachFileType = null;
              fileName = '';
              fileUrl = '';
              if (!(fileList.length > 0)) {
                _context4.next = 3;
                break;
              }
              file = fileList[0].raw;
              path = "pdf_files/client_attendance/".concat((0, _v.default)());
              fileData = this.getUploadFileInfo(file, path);
              _context4.next = 1;
              return this.uploadFileToStorage(file, fileData.path);
            case 1:
              fileUrl = _context4.sent;
              if (!(fileUrl === null)) {
                _context4.next = 2;
                break;
              }
              this.$notify({
                title: '失敗',
                message: 'ファイルをアップロードできませんでした。',
                type: 'error',
                duration: 5000
              });
              this.loading = false;
              this.waitDialogVisible = false;
              return _context4.abrupt("return");
            case 2:
              attachFileType = fileData.type;
              fileName = fileData.name;
            case 3:
              form.fileUrl = fileUrl;
              form.attachFileType = attachFileType;
              form.fileName = fileName;
              _context4.next = 4;
              return this.insertAttendance(form).then(function (resultAttendance) {
                _this.loading = false;
                _this.waitDialogVisible = false;
                _this.$notify({
                  title: '成功',
                  message: '勤怠情報を追加しました。',
                  type: 'success',
                  duration: 5000
                });
                return _this.$router.push({
                  name: 'AttendanceIndex',
                  params: {
                    id: (0, _auth.getClientID)()
                  }
                });
              }).catch(function (error) {
                console.log(error);
                _this.loading = false;
                _this.waitDialogVisible = false;
                _this.$notify({
                  title: '失敗',
                  message: '勤怠情報を追加できませんでした。',
                  type: 'error',
                  duration: 5000
                });
              });
            case 4:
              return _context4.abrupt("return", _context4.sent);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function postFormSubmit(_x2, _x3) {
        return _postFormSubmit.apply(this, arguments);
      }
      return postFormSubmit;
    }()
  }
};